<template>
  <div>
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('invoice.settings')" class="mar-bt-0"></general-top-bar> -->
      <!--End General Top Bar -->
      <div id="outer-container">
          <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
              <div class="card-content">
                  <div class="clearfix row pad-lf-10 pad-rg-10">
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isSeries }"
                        @click="openSeries"
                      >{{$t('invoice.series')}}</a>
                  </div>
              </div>
          </div>
      </div>
      <div v-if="isSeries">
          <div class="card">
              <div class="card-content">
                <form class="clearfix row">
                      <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>{{ $t('invoice.series') }}</label>
                                  <input type="text" class="form-control" v-model="series" :placeholder="$t('invoice.series')"/>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>{{ $t('invoice.startNumber') }}</label>
                                  <input type="number" class="form-control" v-model="startNumber" :placeholder="$t('invoice.startNumber')" />
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label>{{ $t('invoice.endNumber') }}</label>
                                  <input type="number" class="form-control" v-model="endNumber" :placeholder="$t('invoice.endNumber')" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            type="submit"
                            class="btn btn-icon btn-success mar-rt-10 save"
                            style="margin-bottom: 0;"
                            @click.prevent="saveSeries"
                            :title="$t('general.save')"
                          >{{ $t('general.save') }}</button>
                      </div>
                </form>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import swal from 'sweetalert2'
import {Input} from 'element-ui'

export default {
  components: {
    // GeneralTopBar,
    [Input.name]: Input
  },
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    }
  },
  data () {
    return {
      loading: false,
      isSeries: true,
      series: '',
      startNumber: null,
      endNumber: null,
      vatNumber: null
    }
  },
  mounted () { },
  created () {
    this.companyID = this.$session.get('selectedCompany')
    this.vatNumber = this.$session.get('getVatNumber')
  },
  methods: {
    openSeries () {
      this.isSeries = true
    },
    async saveSeries () {
      if (!this.series || !this.startNumber || !this.endNumber) {
        swal({
          title: 'Error',
          text: 'All fields are required for the series.',
          type: 'error',
          timer: 1500,
          showConfirmButton: false
        })
        return
      }
      const seriesData = {
        externalCompanyId: this.companyID,
        vatNumber: this.vatNumber,
        series: this.series,
        startNumber: this.startNumber,
        endNumber: this.endNumber
      }

      try {
        // Facem request-ul pentru a salva compania, presupunând că nu există
        const companyResponse = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/company`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            vatNumber: seriesData.vatNumber,
            name: this.$session.get('companyName')  // Presupunem că numele companiei este stocat în sesiune
          })
        })

        if (!companyResponse.ok) {
          throw new Error('Error saving company')
        }

        const companyData = await companyResponse.json()
        console.log('Company saved successfully:', companyData)

        // După ce compania este salvată, încercăm să salvăm seria
        const seriesResponse = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/series`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(seriesData)
        })

        if (!seriesResponse.ok) {
          throw new Error('Error saving series')
        }

        const seriesDataResponse = await seriesResponse.json()
        console.log('Series saved successfully:', seriesDataResponse)

        swal({
          title: 'Success',
          text: 'Series saved successfully.',
          type: 'success',
          timer: 1500,
          showConfirmButton: false
        })
      } catch (error) {
        console.error('Error saving series:', error)

        swal({
          title: 'Error',
          text: error.message,
          type: 'error',
          timer: 1500,
          showConfirmButton: false
        })
      }
    }
  }
}
</script>

<style scoped>
.el-date-editor .el-range-separator {
  padding: 0 2px;
}
#outer-container .navButtons .card-content {
  padding-left: 0px;
}
.el-table .cell {
  height: 55px;
}
.pull-right.legend {
  margin-top: 15px;
  cursor: pointer;
  text-decoration: underline;
}
.info-text {
  font-size: 13px;
  font-weight: 400;
  color: #000;
  background-color: white;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Invoice/InvoiceSettings.vue